export const DsfNavTree = dsf.defineAsyncComponent("DsfNavTree", () =>
  import(/* webpackChunkName: "platform_pc_tree_module" */ "./navTree/navTree.vue")
);
export const DsfTree = dsf.defineAsyncComponent("DsfTree", () =>
  import(/* webpackChunkName: "platform_pc_tree_module" */ "./treeSelector/tree.vue")
);
export const DsfTreeSelector = dsf.defineAsyncComponent("DsfTreeSelector", () =>
  import(/* webpackChunkName: "platform_pc_tree_module" */ "./treeSelector/treeSelector.vue")
);
export const DsfCheckNode = dsf.defineAsyncComponent("DsfCheckNode", () => {
  //DsfCheckNode组件依赖于DsfTreeSelector，而DsfTreeSelector又是一个异步组件
  return dsf.requestAsyncComponents(DsfTreeSelector).then(() => {
    return import(/*webpackChunkName:"platform_pc_tree_module"*/ "./treeSelector/checkNode");
  });
});

export const DsfTreeInfo = dsf.defineAsyncComponent("DsfTreeInfo", () =>
  import(/*webpackChunkName:"platform_pc_tree_module"*/ "./treeInfo.vue")
);
export const DsfCustomDropTree = dsf.defineAsyncComponent("DsfCustomDropTree", () =>
  import(/*webpackChunkName:"platform_pc_tree_module"*/ "./drop/customDropTree")
);
export const DsfCustomDropTreeLogicNode = dsf.defineAsyncComponent(
  "DsfCustomDropTreeLogicNode",
  () => import(/* webpackChunkName: "platform_pc_tree_module" */ "./drop/template/logicNode.js")
);
